import createIcon from '../../createIcon';

/**
 * @component @name Troubleshoot
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIuNSAyMC4wOUwxNy44MSAxNS40QzE4Ljg3IDE0LjA1IDE5LjUgMTIuMzUgMTkuNSAxMC41QzE5LjUgNi4wOCAxNS45MiAyLjUgMTEuNSAyLjVDNy40MiAyLjUgNC4wNiA1LjU1IDMuNTcgOS41SDUuNTlDNi4wNyA2LjY3IDguNTMgNC41IDExLjUgNC41QzE0LjgxIDQuNSAxNy41IDcuMTkgMTcuNSAxMC41QzE3LjUgMTMuODEgMTQuODEgMTYuNSAxMS41IDE2LjVDOS4wOCAxNi41IDcgMTUuMDYgNi4wNSAxM0gzLjlDNC45NSAxNi4xOSA3Ljk2IDE4LjUgMTEuNSAxOC41QzEzLjM1IDE4LjUgMTUuMDUgMTcuODcgMTYuNCAxNi44MUwyMS4wOSAyMS41TDIyLjUgMjAuMDlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNOC45MyA5LjE5TDEwLjE1IDE0LjVIMTEuNzlMMTMuMDUgMTAuNzJMMTQgMTNIMTZWMTEuNUgxNUwxMy43NSA4LjVIMTIuMjFMMTEuMDkgMTEuODdMOS44NSA2LjVIOC4yTDYuOTUgMTAuNUgxLjVWMTJIOC4wNUw4LjkzIDkuMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Troubleshoot = createIcon('Troubleshoot', [
  [
    'path',
    {
      d: 'M22.5 20.09L17.81 15.4C18.87 14.05 19.5 12.35 19.5 10.5C19.5 6.08 15.92 2.5 11.5 2.5C7.42 2.5 4.06 5.55 3.57 9.5H5.59C6.07 6.67 8.53 4.5 11.5 4.5C14.81 4.5 17.5 7.19 17.5 10.5C17.5 13.81 14.81 16.5 11.5 16.5C9.08 16.5 7 15.06 6.05 13H3.9C4.95 16.19 7.96 18.5 11.5 18.5C13.35 18.5 15.05 17.87 16.4 16.81L21.09 21.5L22.5 20.09Z',
      key: '1odjzx',
    },
  ],
  [
    'path',
    {
      d: 'M8.93 9.19L10.15 14.5H11.79L13.05 10.72L14 13H16V11.5H15L13.75 8.5H12.21L11.09 11.87L9.85 6.5H8.2L6.95 10.5H1.5V12H8.05L8.93 9.19Z',
      key: '1ahddf',
    },
  ],
]);

export default Troubleshoot;
